"use strict";

const $ = jQuery;

module.exports = class {
	#$module;
    #$accordion;
    #$toggle;
    #$siteHeader;
    #$siteHeaderNavBar;

	#data;

	constructor($module, data) {
        this.#data = data;
		this.#$module = $module;
        this.#$accordion = $module.find('.accordion');
        this.#$toggle = $module.find('.accordion-header > .accordion-button');
        this.#$siteHeader = $('body > header');
        this.#$siteHeaderNavBar = this.#$siteHeader.find('nav.navbar');

        this.bind();

        const anchorId = `#${this.getAnchorId()}`;

        requestAnimationFrame(() => {
            if (location.hash === anchorId) {
                if (!this.isExpanded()) {
                    this.#$toggle.trigger('click');
                }
                this.scrollTo();
            }
        });
	}

    bind() {
        $(window).on('hashchange', this.onHashChange);

        this.$accordion.on('show.bs.collapse', this.onAccordionOpen);
        this.$accordion.on('hide.bs.collapse', this.onAccordionClose);
        
        $('html').on(`bb-lumeris:lum-simple-accordion:${this.data.parent}:close`, this.onTriggerAccordionClose);
    }

    get $module() {
        return this.#$module;
    }

    get $accordion() {
        return this.#$accordion;
    }

    get $toggle() {
        return this.#$toggle;
    }

    get $siteHeader() {
        return this.#$siteHeader;
    }

    get $siteHeaderNavBar() {
        return this.#$siteHeaderNavBar;
    }

    get data() {
        return this.#data;
    }

    get id() {
        return this.data.settings.id;
    }

    get moduleId() {
        return this.data.node;
    }

    getAnchorId() {
        return (this.data.settings.anchor_id) ? this.data.settings.anchor_id : `${this.data.node}-accordion`;
    }

    isExpanded() {
        return (this.$toggle.hasClass('collapsed') && this.$toggle.attr('aria-expanded') === 'false') ? false : true;
    }

    hasAnalyticsConsent() {
        return (typeof Cookiebot !== 'undefined') ? Cookiebot.consent?.statistics : true;
    }

    scrollTo() {
        const scrollTopMargin = Number(this.$module.css('scroll-margin-top').split('px').join('')) || Number(this.$accordion.css('scroll-margin-top').split('px').join(''));
        $(window).scrollTop(this.$module.offset().top - this.$siteHeaderNavBar.height() - scrollTopMargin);
    }
    
    onHashChange = (event) => {
        if (event.type !== 'hashchange') {
            return null;
        } 

        if (location.hash === `#${this.getAnchorId()}` && !this.isExpanded()) {
            this.$toggle.trigger('click');
        }
    }

    onTriggerAccordionClose = (event, data) => {
        if (event.type !== `bb-lumeris:lum-advanced-accordion:${this.data.parent}:close`) {
            return null;
        }

        if (data.moduleId === this.moduleId) {
            return null;
        }
    }

    onAccordionOpen = (event) => {
        if (event.namespace !== 'bs.collapse' || event.type !== 'show') {
            return null;
        }

        if ((this.data.settings.event_on_open_active ?? null === 'yes') && window.dataLayer && this.hasAnalyticsConsent()) {
            dataLayer.push({
                event: 'accordionOpen',
                id: this.data.settings.anchor_id,
                label: this.data.settings.label,
                pageUrl: location.href
            });
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'accordion_open' }}));
    }

    onAccordionClose = (event) => {
        if (event.namespace !== 'bs.collapse' || event.type !== 'hide') {
            return null;
        }

        if ((this.data.settings.event_on_close_active ?? null === 'yes') && window.dataLayer && this.hasAnalyticsConsent()) {
            dataLayer.push({
                event: 'accordionClose',
                id: this.data.settings.anchor_id,
                label: this.data.settings.label,
                pageUrl: location.href
            });
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'accordion_close' }}));
    }
}